// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,body{font-family:\"Source Sans Pro\",sans-serif}body{height:100vh;min-height:100vh;max-height:100vh}body #root{height:100%;display:flex;flex-direction:column}body #root .navbar .alert{padding-bottom:.45rem;padding-top:.45rem}body #root main{flex:1 1 auto;min-height:1px;position:relative}", ""]);
// Exports
module.exports = exports;
